<template>
  <section class="filters__footer">
    <FiltersClear
      :clearFiltersText="clearFiltersText"
      :clearAllFilters="clearAllFilters"
    ></FiltersClear>
    <div class="filters__buttons-wrapper">
      <button
        class="button button-tertiary filters__hide-filters"
        @click="closeShowOptions"
      >
        Close filters
        <span class="icon icon-cross-open"></span>
      </button>
      <FiltersApplyButton
        class="filters__apply-button"
        :APICall="APICall"
        :applyFiltersText="applyFiltersText"
        :applyFiltersToAPICall="applyFiltersToAPICall"
        :updateShowOptions="updateShowOptions"
      ></FiltersApplyButton>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import FiltersApplyButton from "./FiltersApplyButton.vue";
import FiltersClear from "./FiltersClear.vue";

export default Vue.component("FiltersFooter", {
  props: {
    APICall: Function,
    applyFiltersText: String,
    applyFiltersToAPICall: Function,
    clearAllFilters: Function,
    clearFiltersText: String,
    locations: Array,
    updateShowOptions: Function,
  },
  components: {
    FiltersApplyButton,
    FiltersClear,
  },
  methods: {
    closeShowOptions: function() {
      this.updateShowOptions(false);
    },
  },
});
</script>
